import React from 'react';
import agent, { Agent } from './modules/agent';
import auth, { Auth } from './modules/auth';
import booking, { Booking } from './modules/booking';
import bookingDetail, { BookingDetail } from './modules/bookingDetail';

export type RootStore = {
  auth: Auth;
  agent: Agent;
  booking: Booking;
  bookingDetail: BookingDetail;
};

export const store: RootStore = {
  auth,
  agent,
  booking,
  bookingDetail
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, agent, booking, bookingDetail };
